import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPartiallySignedPaidOrProcessing, getIsPublished, getIsArchived } from 'quotes-ui-lib/utils/status';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ArchiveButton = ({
  quote,
  onClick
}) => {
  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };
  const disableButton = getIsPartiallySignedPaidOrProcessing(quote);
  return /*#__PURE__*/_jsx(Tooltip, {
    use: "longform",
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.archive.disabledTooltip.heading"
    }),
    title: /*#__PURE__*/_jsxs(List, {
      styled: true,
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.archive.disabledTooltip.unpaid"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.archive.disabledTooltip.notProcessingPayments"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.archive.disabledTooltip.notPartiallySigned"
      })]
    }),
    placement: "top left",
    disabled: !disableButton,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "archive-quote-button",
      use: "tertiary-light",
      onClick: handleButtonClick,
      disabled: disableButton,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.archive.buttonText"
      })
    }, "archiveButton")
  }, "archive");
};
export const showArchiveButton = (quote, canCurrentUserEditQuote) => {
  const isPublished = getIsPublished(quote);
  const isArchived = getIsArchived(quote);
  return isPublished && !isArchived && canCurrentUserEditQuote;
};
export default ArchiveButton;